import _ from 'lodash';
import template from './liveMonitoring.html';


export default {
  name: 'liveMonitoringComponent',
  template,
  controller: LiveMonitoringController,
  controllerAs: 'LiveMonitoringCtrl'
};

/* @ngInject */
function LiveMonitoringController(
  $sails,
  growl,
  $timeout,
  $log,
  uiGridConstants,
  MonitoringService,
  RcuInfoService,
  monitoringGridFactory
) {

  /// ////////////////
  // Local Variables//
  /// ////////////////
  const vm = this;
  const defaultGridSettings = {
    enableColumnMenus: false,
    enableFiltering: true,
    showGridFooter: true,
    showColumnFooter: true,
    enableRowSelection: false,
    enableSelectAll: true,
    multiSelect: true,
    modifierKeysToMultiSelect: true,
    gridMenuShowHideColumns: false,
    enableRowHeaderSelection: false,
    enableColumnResizing: true
  };

  /// ////////////////
  // Public Variables//
  /// ////////////////
  vm.disableGenerateReport = true;
  const rcuGrid = monitoringGridFactory('liveRcu');
  rcuGrid.columnDefs[4].filter = { term: 'Offline' };

  rcuGrid.onRegisterApi = (gridApi) => {
    vm.rcuGridAPI = gridApi;
    const millitime = 700;
    $timeout(() => {
      // this call fixes the issue with the grid rendering smaller on page load
      vm.rcuGridAPI.core.handleWindowResize();
    }, millitime);
  };
  vm.rcuGrid = _.defaults(rcuGrid, defaultGridSettings);

  /// ////////////////
  // Public functions/
  /// ////////////////

  vm.$onInit = init;
  vm.$postLink = setupListeners;
  vm.$onDestroy = handleDestroy;

  function init() {
    return RcuInfoService.getAllRcus()
      .then(rcus => _.set(vm, 'rcuGrid.data', rcus));
  }

  // Since we merge values into the existing object
  // we can count on those mutations to propagate
  // (vs changing the reference)
  const update = (arr, key, newval) => {
    const match = _.find(arr, key);
    if (match) {
      _.merge(match, newval);
    } else {
      arr.push(newval);
    }
  };

  function setupListeners() {
    $sails.on('rcu', (rcu) => {
      growl.info(`Rcu ${rcu.name} is now ${rcu.state}`, { ttl: 5000 });
      update(vm.rcuGrid.data, { id: rcu.id }, rcu);
      vm.rcuGridAPI.core.notifyDataChange(uiGridConstants.dataChange.ROW);
    });

    MonitoringService.joinRoom()
      .catch((err) => {
        $log.error('Could not join monitoring room', err);
      });
  }

  function handleDestroy() {
    $sails.off('rcu');
    MonitoringService.leaveRoom();
  }
}
